export default __webpack_public_path__ + "static/media/calendar.f6b7c564.svg";